import { render, staticRenderFns } from "./CompanyAxonautRelation.vue?vue&type=template&id=303b440a"
import script from "./CompanyAxonautRelation.vue?vue&type=script&lang=js"
export * from "./CompanyAxonautRelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports